/**
 * Trigger analytics v2
 *
 * This sends an event to datalayer on element click.
 * This differs from the original triggerAnalytics module in that it does not force event to be "dlToAnalytics".
 * All element data attributes, that start with 'data-gtm-' are added to the event object. 'data-gtm-event' is required, others optional.
 * Note that attributes are formatted to be snake_case and without gtm-prefix.
 *
 * @example
 * <a href="#" data-gtm-event="event_name" data-gtm-technical-manual-version="light" data-gtm-already_snake_cased="value">Click me</a>
 *
 * results in window.dataLayer push:
 * {
 *  event: 'event_name',
 *  technical_manual_version: 'light',
 *  already_snake_cased: 'value',
 * }
 *
 */
const triggerAnalytics = {
  init: function(elements: NodeListOf<HTMLElement>) {
    console.log('triggerAnalyticsV2.init()');

    window.dataLayer = window.dataLayer || [];

    for(let trigger of elements) {
      // Minimum requirement for event object is event name.
      if(trigger.dataset.gtmEvent) {
        trigger.addEventListener('click', this.onElementClick.bind(this));
      }
    }
  },

  onElementClick: function(event: Event) {
    const isAdmin = document.body.classList.contains('view-admin-editor');
    const trigger = event.target as HTMLElement;

    const eventObj = {
      event: trigger.dataset.gtmEvent,
    };

    // Check other data attributes for all gtm-prefixed attributes
    for(let key in trigger.dataset) {
      const value = trigger.dataset[key];
      if(key.startsWith('gtm') && value) {
        const newKey = this.camelToSnakeCase(key.replace('gtm', ''));
        eventObj[newKey] = value;
      }
    }

    if(!isAdmin) {
      window.dataLayer.push(eventObj);
    } else {
      console.log(`triggerAnalyticsV2: ${JSON.stringify(eventObj, null, 2)}`);
    }
  },

  camelToSnakeCase: (str) => {
    let snakeCased = str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);

    // If PascalCase originally, remove leading underscore
    if (snakeCased.startsWith('_')) {
      snakeCased = snakeCased.substring(1);
    }

    return snakeCased;
  },
}

export default triggerAnalytics;
